import { Dropdown, Form, Select } from "semantic-ui-react";
import ErrorsView from "./ErrorsView";
import { FormError } from "../models/FormError";
import { OrgUser } from "../models/OrgUser";
import { PermitTypeOrgRole } from "../models/PermitTypeOrgRole";

export interface FormData {
  id: string;
  orgUserIds: string[];
  permitTypeOrgRoleId: string;
}

interface Props {
  formData: FormData;
  formErrors: FormError;
  errors: string[] | undefined;
  onChange: (formData: FormData) => void;
  users?: OrgUser[];
  permitTypeOrgRoles?: PermitTypeOrgRole[];
}

const AddRegisterAssignmentForm = ({ formData, onChange, formErrors, errors, users, permitTypeOrgRoles }: Props) => {
  const handleChange = (e: any, { name, value }: any) => {
    onChange({ ...formData, [name]: value });
  };

  return (
    <>
      <Form>
        <Form.Group widths="equal">
          <Form.Dropdown
            required
            error={formErrors.orgUserIds}
            control={Dropdown}
            name="orgUserIds"
            fluid
            label="User"
            options={users?.map((u) => ({ key: u.id, text: u.user.displayName, value: u.id }))}
            onChange={handleChange}
            multiple
            selection
            search
          />
        </Form.Group>
        <Form.Group widths="2">
          <Form.Field
            required
            error={formErrors.permitTypeOrgRoleId}
            control={Select}
            name="permitTypeOrgRoleId"
            value={formData.permitTypeOrgRoleId}
            fluid
            label="Role"
            options={permitTypeOrgRoles?.map((r) => ({ key: r.id, text: r.orgRole.displayName, value: r.id }))}
            onChange={handleChange}
          />
        </Form.Group>
      </Form>
      <ErrorsView errors={errors} />
    </>
  );
};

export default AddRegisterAssignmentForm;
